import React from 'react'
import HeaderLink from '../HeaderLink/HeaderLink'

export default function SliceZone(props) {
  const {
    slices,
    setOpen,
    timer,
    setTimer,
    prismicCtx,
    scroll,
    setLinks,
    homePage
  } = props
  return (
    <React.Fragment>
      {slices.map((slice, i) => (
        <React.Fragment key={i}>
          {slice.slice_type === 'header_linkur' && (
            <HeaderLink
              headerLink={slice}
              prismicCtx={prismicCtx}
              scroll={scroll}
              setOpen={setOpen}
              setTimer={setTimer}
              timer={timer}
              setLinks={setLinks}
              homePage={homePage}
            />
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}